import { Col, Divider, Row } from 'antd';
import { MASTER_CATEGORY_LIST } from 'utilities/constants/COMMON';
import { StepProps } from '../props/StepProps';
import { ItemView } from './ItemView';

const YES_NO_OPTIONS = [
    {
        label: 'あり',
        value: '1',
    },
    {
        label: 'なし',
        value: '0',
    },
];

const YES_NO_OPTIONS_DEPEND = [
    {
        label: 'あり',
        value: '10',
    },
    {
        label: 'なし',
        value: '0',
    },
];

export const StepViewTwo = ({ data, masterData }: StepProps) => {
    return (
        <>
            <Row className="min-w-min">
                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">家族</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="配偶者"
                                value={
                                    data?.existFlagRelation && data?.existFlagRelation
                                        ? 'あり'
                                        : 'なし'
                                }
                                options={YES_NO_OPTIONS}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="配偶者の扶養義務"
                                value={
                                    data?.dependentType && data?.dependentType == '10'
                                        ? 'あり'
                                        : 'なし'
                                }
                                options={YES_NO_OPTIONS_DEPEND}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="子供"
                                value={data?.count01}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="扶養の子供"
                                value={data?.dependentCountChild}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="同居している子供"
                                value={data?.livingTogetherCount}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="扶養している父母"
                                value={data?.dependentCountParent}
                                labelClassName="content-step-form label-step-form"
                                suffix="人"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[48px]">
                    <span className="content-step-form heading-step-form">その他</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                options={
                                    masterData?.[
                                        MASTER_CATEGORY_LIST.HOME_BUILDING_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="自宅の建物区分"
                                value={data?.homeBuildingType}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                options={
                                    masterData?.[
                                        MASTER_CATEGORY_LIST.HOME_POSSESSION_TYPE_CLASSIFICATION
                                    ]
                                }
                                label="自宅の所有区分"
                                value={data?.homePossessionType}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="住宅ローン残債"
                                value={data?.housingLoanBalance}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                options={YES_NO_OPTIONS}
                                label="投資用不動産"
                                value={data?.existFlagProperty}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="区分マンション（戸数）"
                                value={data?.quantity01}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="戸"
                            />
                        </Col>
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="一棟アパート・戸建て（棟数）"
                                value={data?.quantity02}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="棟"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <ItemView
                                label="投資用不動産詳細（任意）"
                                value={data?.others01}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                options={YES_NO_OPTIONS}
                                label="その他所有不動産"
                                value={data?.existFlagPropertyOther}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>

                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={24} className="pr-[12px]">
                            <ItemView
                                label="その他所有不動産詳細"
                                value={data?.others02}
                                labelClassName="content-step-form label-step-form"
                            />
                        </Col>
                    </Row>
                </div>

                <div className="w-full mb-[9px]">
                    <span className="content-step-form heading-step-form">借入</span>
                    <Divider className="mb-6 my-1" />
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="借入額（自宅）"
                                value={data?.loanAmountHouse}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="借入額（自動車）"
                                value={data?.loanAmountCar}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                    <Row gutter={[0, 12]} className="mb-6">
                        <Col span={12} className="pr-[12px]">
                            <ItemView
                                label="借入額（投資用不動産）"
                                value={data?.loanAmountInvest}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                        <Col span={12} className="pl-[12px]">
                            <ItemView
                                label="借入額（その他）"
                                value={data?.loanAmountOther}
                                type="number"
                                labelClassName="content-step-form label-step-form"
                                suffix="万円"
                            />
                        </Col>
                    </Row>
                </div>
            </Row>
        </>
    );
};
